import styled from 'styled-components';
import { ModalFeaturesStyled } from '../ModalFeaturesStyled';
import { rem } from 'polished';

export const ModalFeaturesStyledAP = styled(ModalFeaturesStyled)``;
